import React from 'react'
import requiresLoggedIn from 'views/hoc/loggedIn'
import {Col, Row} from 'components/Display'
import {AppPageContainer} from 'views/Containers'
import services from 'services'
import Spinner from 'components/Spinner'
import i18n from 'i18n'
import UserAvatar from 'components/UserAvatar'
import {NavLink, Route, Switch, useLocation} from 'react-router-dom'
import UserInfoView from './Info'
import UserBillingView from './Billing'

const userRoutes = [
  {path: '/user', name: 'Info', isSelected: (pathname: string) => pathname === '/user'},
  {path: '/user/billing', name: 'Billing'},
]

function UserView() {
  const service = services.getUserService()
  const [user, isLoadingUser] = service.user.hook()
  const location = useLocation()

  if (isLoadingUser) {
    return (
      <AppPageContainer>
        <Col className="flex-1 justify-center items-center">
          <Spinner />
        </Col>
      </AppPageContainer>
    )
  }

  if (user == null) {
    return (
      <AppPageContainer>
        <Col className="flex-1 justify-center items-center">{i18n.t('misc.couldNotLoadData')}</Col>
      </AppPageContainer>
    )
  }

  return (
    <AppPageContainer>
      <Col className="flex-1">
        <Row className="p-4 border-b shadow-b bg-white items-center">
          <UserAvatar user={user} />
          <div className="text-lg font-bold ml-2">{`${user.firstName} ${user.lastName}`}</div>
        </Row>
        <Row className="flex-1">
          <Col className="p-4 w-1/6 bg-white">
            {userRoutes.map((r) => {
              const isSelected = r.isSelected ? r.isSelected(location.pathname) : location.pathname.includes(r.path)
              return (
                <NavLink key={r.path} to={r.path}>
                  <div
                    className={`
                    mb-2
                    hover:shadow p-2 rounded border cursor-pointer
                    ${isSelected ? 'font-bold' : ''}
                    ${isSelected ? 'bg-itx-primary-3' : ''}
                    ${isSelected ? 'text-white' : ''}
                    `}
                  >
                    {r.name}
                  </div>
                </NavLink>
              )
            })}
          </Col>
          <Col className="flex-1 p-4 border-l">
            <Switch>
              <Route exact path="/user" component={UserInfoView} />
              <Route path="/user/billing" component={UserBillingView} />
            </Switch>
          </Col>
        </Row>
      </Col>
    </AppPageContainer>
  )
}

export default requiresLoggedIn(UserView)
